import axiosInstance from "../../axiosInstance";

const BASE_URL = "/crm/contract-documents";

export const getAllContractDocuments = async (params = {}) => {
  const response = await axiosInstance.get(BASE_URL, { params });
  return response.data;
};

export const getContractDocumentStats = async (params = {}) => {
  const response = await axiosInstance.get(`${BASE_URL}/stats`, { params });
  return response.data;
};

export const createContractDocument = async (formData) => {
  const response = await axiosInstance.post(BASE_URL, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteContractDocument = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};
